import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

export const AGENT_NAME = {
    ONBOARDING: 'onboarding',
    BUDGET_NEGOTIATION: 'budget_negotiation',
    CAMPAIGN_UNDERPERFORMING: 'campaign_underperforming',
    REPORTING_AGENT: 'reporting_agent',
};

export const MESSAGE_DIRECTION = {
    INCOMING: 'incoming',
    OUTGOING: 'outgoing',
};

export const CHAT_TEST_ID_PREFIX = {
    CHAT_AGENT: 'chat-agent',
    CHATKIT: 'chatkit',
};

export const OPENAI_CHATKIT_TEST_ID = 'openai-chatkit';

export const reportAgentQuestionOptions = [
    {
        value: 'adjust-bidding-strategy',
        label: (
            <FormattedMessage
                id="user.question.abby.report.assistant.ads.highest.ctr"
                defaultMessage="Which ads are driving the highest CTR?"
            />
        ),
    },
    {
        value: 'top-performing-thumbnails',
        label: (
            <FormattedMessage
                id="user.question.abby.report.assistant.best.converting.campaigns"
                defaultMessage="Which campaigns are converting best?"
            />
        ),
    },
    {
        value: 'account-mix-evolve',
        label: (
            <FormattedMessage
                id="user.question.abby.report.assistant.highest.cpa"
                defaultMessage="Which ads have the highest CPA?"
            />
        ),
    },
    {
        value: 'campaigns-cvr-decreasing',
        label: (
            <FormattedMessage
                id="user.question.abby.report.assistant.campaigns.spent.most"
                defaultMessage="Which campaigns spent the most?"
            />
        ),
    },
    {
        value: 'most-frequent-ads-titles',
        label: (
            <FormattedMessage
                id="user.question.abby.report.assistant.lowest.cpc.ads"
                defaultMessage="Which ads are delivering the lowest CPC?"
            />
        ),
    },
];
